var __jsx = React.createElement;
import React, { useEffect, useState } from 'react';
import MuscleModal from '@modules/shared/components/modal';
import CustomerPasswordRecoveryForm from './components/customer-password-recovery-form';
import customersManager from '@lib/data/managers/shared/customers-manager';
import { useTranslations } from 'next-intl';
import ForgotPasswordEmailSentModal from './components/email-sent-modal';
const ForgotPasswordFlow = _ref => {
  let {
    isOpen,
    setIsOpen
  } = _ref;
  const t = useTranslations('Shared.Auth');
  const {
    0: emailSentModalIsOpen,
    1: setEmailSentModalIsOpen
  } = useState(false);
  const {
    0: isSendingEmail,
    1: setIsSendingEmail
  } = useState(false);
  const {
    0: emailEntry,
    1: setEmailEntry
  } = useState('');
  const {
    0: errorSendingEmail,
    1: setErrorSendingEmail
  } = useState(false);
  const {
    0: errorMessage,
    1: setErrorMessage
  } = useState('');
  useEffect(() => {
    if (isOpen) {
      setEmailEntry('');
      setErrorSendingEmail(false);
      setErrorMessage('');
      setEmailSentModalIsOpen(false);
      setIsSendingEmail(false);
    }
  }, [isOpen]);
  const sendEmail = async () => {
    setIsSendingEmail(true);
    const emailSentResponse = await customersManager.sendResetPasswordEmail(emailEntry);
    if ('error' in emailSentResponse) {
      setErrorSendingEmail(true);
      setErrorMessageBasedOnErrorCode(emailSentResponse.code);
    } else {
      openEmailSentModal();
    }
    setIsSendingEmail(false);
  };
  const setErrorMessageBasedOnErrorCode = errorCode => {
    switch (errorCode) {
      case 'auth-006':
        setErrorMessage(t('EMAIL_NOT_REGISTERED'));
        break;
      case 'auth-003':
        setErrorMessage(t('USER_BLOCK_ERROR'));
        break;
      default:
        setErrorMessage(t('AN_ERROR_HAS_OCURRED'));
        break;
    }
  };
  const openEmailSentModal = () => {
    setIsOpen(false);
    setEmailSentModalIsOpen(true);
  };
  return __jsx(React.Fragment, null, __jsx(MuscleModal, {
    openState: isOpen,
    setOpenState: setIsOpen
  }, __jsx(CustomerPasswordRecoveryForm, {
    onClickCancel: () => setIsOpen(false),
    onClickSendEmail: sendEmail,
    isSendingEmail: isSendingEmail,
    emailEntry: emailEntry,
    setEmailEntry: setEmailEntry,
    errorSendingEmail: errorSendingEmail,
    errorMessage: errorMessage
  })), __jsx(ForgotPasswordEmailSentModal, {
    isOpen: emailSentModalIsOpen,
    setIsOpen: setEmailSentModalIsOpen,
    email: emailEntry,
    sendEmail: sendEmail,
    isSendingEmail: isSendingEmail
  }));
};
export default ForgotPasswordFlow;